import React, { Component } from 'react';
import PropTypes from 'prop-types';
import scrollIntoView from 'scroll-into-view';
import { DomUtils, Highlighter } from '@onsolve/onsolve-ui-components';

import withKeyboardControl from '@components/GlobalSearch/Utils/KeyboardControl';
import keyCodes from '@components/GlobalSearch/Utils/keyCodes';

class SearchSuggestions extends Component {
    constructor(props) {
        super(props);

        this.elementRef = React.createRef();
    }

    componentDidUpdate() {
        const { selectedId } = this.props;
        const { current } = this.elementRef;

        if (selectedId && current) {
            DomUtils.setFocus(current);
            scrollIntoView(current, {
                time: 100
            });
        }
    }

    handleKeyDown = translatedTitle => e => {
        const { keyCode } = e;
        const { ENTER_KEY } = keyCodes;
        const { onItemClick } = this.props;

        keyCode === ENTER_KEY && onItemClick(translatedTitle);
    };

    handleClick = translatedTitle => () => {
        const { onItemClick } = this.props;

        onItemClick(translatedTitle);
    };

    render() {
        const { suggestions, onKeyDown, isSelected, selectedId } = this.props;
        return (
            <div onKeyDown={onKeyDown}>
                {suggestions.map(({ results, term }) =>
                    results.map(({ id, translatedTitle }) => (
                        <div
                            key={id}
                            ref={isSelected && id === selectedId ? this.elementRef : undefined}
                            onClick={this.handleClick(translatedTitle)}
                            onKeyDown={this.handleKeyDown(translatedTitle)}
                            tabIndex={0}
                            className="onsolve-menu-search__body__suggestion-item"
                            data-test="suggestion-item"
                        >
                            <Highlighter search={term} className="text-primary font-weight-bold">
                                {translatedTitle}
                            </Highlighter>
                        </div>
                    ))
                )}
            </div>
        );
    }
}

SearchSuggestions.propTypes = {
    isSelected: PropTypes.bool,
    onItemClick: PropTypes.func,
    onKeyDown: PropTypes.func,
    selectedId: PropTypes.string,
    suggestions: PropTypes.array
};

export default withKeyboardControl(SearchSuggestions);
